<template>
    <div class="w-full flex flex-column gap-5
        px-0 xl:px-3 lg:px-3 md:px-3">
        <WalletWidget @refresh="getWallets"
            :title="content[lang].walletTitle"
            :balance=stateBalance 
            :currency="depositWalletCurrency" 
            :wallets="wallets"
            :wallet_id="depositWalletId" 
            :wallet_type="'deposit'"
            :deposit_wallet_id="depositWalletId" 
            :loading="loading" 
            :btnWithdraw="isUserInGroup('merchant', 'manager', 'admin', 'tester')"
            />
        
        <div class="w-full flex gap-5 mb-3
            px-3 xl:px-0 lg:px-0 md:px-0
            flex-column xl:flex-row lg:flex-row md:flex-row">

            <!--WalletList-->
            <div v-if="walletsCount>1" class="w-full flex flex-column xl:w-4 lg:w-4">
                <div class="w-full flex flex-row">
                    <div class="flex flex-1 align-items-center">
                        <span class="text-xl font-medium text-900 h-3rem">{{ content[lang].wallets }}</span>
                    </div>
                    <div class="flex">
                        <!-- <Button label="Все акк." @click="toAccounts(wallet_id)" size="small" severity="secondary"
                            class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded /> -->
                    </div>
                </div>
                <div class="w-full flex">
                    <div v-if="!loading && wallets && wallets.length>0" class="w-full">
                        <div class="w-full flex flex-column surface-0 cursor-pointer
                            align-items-left overflow-hidden justify-content-start
                            border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl">
                            <div v-for="w of wallets" @click="toWallet(w.ext_type)" 
                                class="w-full flex flex-row px-3 py-3 gap-3 border-bottom-1 border-100">

                                <div class="flex flex-row flex-1 align-items-center justify-content-start gap-1">
                                    <div class="flex">
                                        <Avatar v-if="w.ext_type === 'merhcant'" icon="pi pi-shop" class="mr-2 text-600" size="small" shape="circle" />
                                        <Avatar v-else-if="w.ext_type === 'partner'" icon="pi pi-percentage" class="mr-2 text-600" size="small" shape="circle" />
                                        <Avatar v-else-if="w.ext_type === 'deposit'" icon="pi pi-plus" class="mr-2 text-600" size="small" shape="circle" />
                                        <Avatar v-else-if="w.ext_type === 'vcard'" icon="pi pi-credit-card" class="mr-2 text-600" size="small" shape="circle" />
                                        <Avatar v-else icon="pi pi-file" class="mr-2 text-600" size="small" shape="circle" />
                                    </div>
                                    <div class="flex flex-column flex-1">
                                        <span class="flex text-900 text-sm font-medium text-left">
                                            {{ getWalletNameByType(w.ext_type) }}
                                        </span>
                                    </div>
                                </div>

                                <div class="flex flex-row align-items-center gap-2 justify-content-end">
                                    <div class="flex flex-row flex-1 gap-1 text-right">
                                        <span class="flex text-900 text-sm font-medium">
                                            {{ get_format_amount(w.balance, null, 2) }}
                                        </span>
                                        <span class="flex text-sm text-500 uppercase font-medium">
                                            {{ 'usdt' }}
                                        </span>
                                    </div>
                                    <div class="flex">
                                        <i class="pi pi-arrow-right text-500"></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Skeleton v-if="loading" height="2rem" class="mb-3" /> 
                </div>
            </div>

            <!--Transactions-->
            <div class="w-full flex flex-column xl:w-8 lg:w-8">
                <div class="w-full flex flex-row mb-3">
                    <div class="flex flex-1 align-items-center">
                        <span class="text-xl font-medium text-900 h-2rem">{{ content[lang].transactions }}</span>
                    </div>
                    <div class="flex">
                        <Button v-if="!loading && transactions && transactions.length>0"
                            :label="content[lang].transactionsBtn" @click="toTransactions()" size="small" severity="secondary"
                            class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded />
                    </div>
                </div>
                <div class="w-full flex">
                    <Transactions v-if="!loading && transactions && transactions.length>=0"
                        :transactions="transactions" :loading="loading"/>
                    <Skeleton v-if="loading" height="2rem" class="mb-3" /> 
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Connect          from '@/assets/js/Connect'
import Helper           from '@/assets/js/Helper'
import WalletWidget     from '@/components/personal/wallet/WalletWidget.vue'
import Transactions     from '@/components/personal/Transactions.vue'
import { mapActions }   from 'vuex'

export default {
    data() {
        return {
            content: {
                ru: { 
                    walletTitle: 'Общий счет',
                    topupBtn: 'Пополнить',
                    withdrawBtn: 'Вывести',
                    exchangeBtn: 'Обменять',
                    wallets: 'Счета',
                    transactions: 'Транзакции',
                    transactionsBtn: 'Все транзакции',
                    popupTopupTransfer: 'Перевод с карты',
                    popupTopupTitle: 'Пополнить с карты',
                    popupTopupTopup: 'Пополнить криптовалютой',
                    popupTopupExchange: 'Обменять',
                    popupWithdrawCrypto: 'Вывести криптовалюту',
                    popupWithdrawBtn: 'Вывести',
                    popupTopupBtn: 'Пополнить'
                },
                en: { 
                    walletTitle: 'Total balance',
                    topupBtn: 'Top up',
                    withdrawBtn: 'Withdraw',
                    exchangeBtn: 'Exchange',
                    wallets: 'Accounts',
                    transactions: 'Transactions',
                    transactionsBtn: 'All transactions',
                    popupTopupTransfer: 'Transfer from card',
                    popupTopupTitle: 'Top up from card',
                    popupTopupTopup: 'Top up with cryptocurrency',
                    popupTopupExchange: 'Exchange',
                    popupWithdrawCrypto: 'Withdraw cryptocurrency',
                    popupWithdrawBtn: 'Withdraw',
                    popupTopupBtn: 'Top up'
                },
            },
            wallet_id: null,
            transactions: [],
            loading: false,
            wallets: [],
            depositWalletId: null,
            depositWalletCurrency: null
        }
    },
    components: {
        WalletWidget,
        Transactions
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        stateBalance() { return this.$store.getters.StateTotalBalance },
        transactions() { return this.$store.getters.StateTransactions },
        depositWalletId() { return this.getDepositWalletId(this.$store.getters.StateWallets)},
        depositWalletCurrency() { 
            const depositWallet = this.$store.getters.StateWallets.find(wallet => wallet.type === 'deposit');
            return depositWallet?.account_details?.[0]?.currency || null;
        },
        loadingWallets() { return this.$store.getters.StateLoadingWallets },
        walletsCount(){
            if (this.wallets && this.wallets.length > 0) {
                return this.wallets.length
            } else {
                return 0
            }
        }
    },
    watch: {
        loadingWallets(newVal) {
           this.loading = newVal
        },
    },
    methods: {
        ...mapActions(['ActionGetAllWallets', 'SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)},
        get_format_amount(value, currency, digits) {
            return this.helper.format_amount(value, currency, digits)
        },
        toTransactions() {
            this.$router.push({ path: '/personal/transactions/'})
        },
        toWallet(type) {
            this.$router.push({ path: `/personal/wallet/${type}/` })
        },
        getFormatDate(date) {
            return this.helper.format_date_short(date)
        },
        getWalletNameByType(type) {
            return this.helper.getWalletNameByType(type, this.lang)
        },
        getDepositWalletId(list) {
            if(!list || !Array.isArray(list)) return null
            if(list && list.length > 0) {
                for (let i = 0; i < list.length; i++) {
                    if(list[i].type == 'deposit') return list[i].id
                }
            } else return null
        },
        async getWallets() {
            this.loading = true
            try {
                const resWallets = await this.ActionGetAllWallets().then(res=>res)
                if(resWallets.result && resWallets.data) {
                    this.wallets = resWallets.data.wallets || []
                    this.transactions = resWallets.data.transactions || []
                }
                else this.wallets = []
            } catch (error) {
                console.log(error)
            }
            this.loading = false
        },
    },
    async beforeCreate() {
        this.helper = new Helper()
        this.connect = new Connect()
    },
    async mounted() {
        this.wallets = this.$store.getters.StateWallets || []
        try {
            this.SetHeaderTitle(this.content[this.lang].walletTitle)
            this.SetHeaderBtnLeftFirst({
                type: 'avatar',
                link: '/personal/profile/',
                icon: 'pi pi-user',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'action',
                action: 'ActionGetAllWallets',
                icon: 'pi pi-sync',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}   
</script>
